<p>email-blast-detail-dialog-def-editor works!</p>
